import ZBreadcrumbs from './ZBreadcrumbs.vue'

export default ZBreadcrumbs
